var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sw-js-blob-svg",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient",
    x1: 0,
    x2: 1,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop1",
    stopColor: "rgba(232, 71, 71, 1)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop2",
    stopColor: "rgba(153, 0, 0, 1)",
    offset: "80%"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sw-gradient)",
    d: "M18.4,-23C23.6,-17.6,27.4,-11.5,30.5,-3.9C33.6,3.7,35.9,12.9,32.8,19.5C29.6,26.1,21,30,11.9,33.9C2.7,37.8,-6.9,41.5,-14.8,39.3C-22.7,37,-29,28.7,-32.5,20C-35.9,11.4,-36.6,2.4,-35.3,-6.4C-34,-15.3,-30.7,-24,-24.5,-29.2C-18.3,-34.5,-9.1,-36.3,-1.3,-34.8C6.6,-33.3,13.2,-28.4,18.4,-23Z",
    width: "100%",
    height: "100%",
    transform: "translate(50 50)",
    strokeWidth: 0,
    style: {
      transition: "all 0.3s ease 0s"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.1f45de3ab217101bdf44d35158eda39b.svg";
export { ForwardRef as ReactComponent };